export default {
  card1: {
    title: '採用管理システム',
    desc: '募集から入社前までの候補者管理',
    useNow: '今すぐ利用',
    lastUsed: '前回使用',
  },
  card2: {
    title: '定着支援システム',
    desc: '外国人材の在留資格および定着管理',
    useNow: '今すぐ利用',
    lastUsed: '前回使用',
  },
  noAccessPermission: '申し訳ございません。アクセス権限がありません。オーナー/管理者に連絡してください。',
};